const colorGradient = {
  colorLeft: '#1455c0',
  colorRight: '#5eedfd',
};
const typeHover = {
  hoverScore: 1,
  hoverValueScore: 2,
  hoverAlertSystem: 3,
};
export default {
  colorGradient,
  typeHover,
};
